//components
import PageInfo from "../../components/PageInfo"
import PageHeader from "../../../PageHeader/PageHeader";
import ImageGallery from "../../components/ImageGallery";
import ContactInfo from "../../components/ContactInfo";
import PageState from "../../components/PageState.js";

//style
import styles from "./index.module.css"

export default function Andre() {
   return(
        <PageState
            pageName="Andre"
            render={({ data, sections, sectionNames }) => {

                const {Sec1, Sec2, Sec3, Gallery, Sec4, Sec5, Sec6, mandagsbedegruppe, u1} = data;

                return(
                    <div>
                        <PageHeader 
                            image={data.PageHeader.imageUrl} 
                            title={data.PageHeader.title} 
                            sections={sections} 
                            description={data.PageHeader.text} 
                            sectionNames={sectionNames}/>

                        <section 
                            id={Sec1.secId}
                            className={styles.sec1}>

                            <PageInfo 
                                title={Sec1.header} 
                                image={""} 
                                description={<div dangerouslySetInnerHTML={{ __html: Sec1.text }}/>} 
                                version={"v1"}/>
                        </section>

                        <section 
                            id={Sec2.secId}
                            className={styles.sec2}>

                            <PageInfo 
                                title={Sec2.header} 
                                image={""} 
                                description={<div dangerouslySetInnerHTML={{ __html: Sec2.text }}/>} 
                                version={"v1"}/>

                            <ContactInfo 
                                where= {Sec2.where} 
                                when={Sec2.when} 
                                who={Sec2.who} 
                                mobile={Sec2.mobile}
                                email={Sec2.email}/>
                        </section>
                        <section className={styles.gallery}>
                            <ImageGallery images={Gallery.images}/>
                        </section>
                        <section 
                            id ={Sec3.secId} 
                            className={styles.sec3}>

                            <PageInfo 
                                title={Sec3.header} 
                                description={<div dangerouslySetInnerHTML={{ __html: Sec3.text }}/>} 
                                image={""} 
                                version={"v1"}/>

                            <ContactInfo 
                                where= {Sec3.where} 
                                when={Sec3.when} 
                                who={Sec3.who} 
                                mobile={Sec3.mobile}
                                email={Sec3.email}/>
                        </section>
                        {Sec4 && (
                            <section 
                                id ={Sec4.secId} 
                                className={styles.sec2}>

                                <PageInfo 
                                    title={Sec4.header} 
                                    description={<div dangerouslySetInnerHTML={{ __html: Sec4.text }}/>} 
                                    image={""} 
                                    version={"v1"}/>

                                <ContactInfo 
                                    where= {Sec4.where} 
                                    when={Sec4.when} 
                                    who={Sec4.who} 
                                    mobile={Sec4.mobile}
                                    email={Sec4.email}/>
                            </section>
                        )}
                        {Sec5 && (<section 
                            id ={Sec5.secId} 
                            className={styles.sec3}>

                            <PageInfo 
                                title={Sec5.header} 
                                description={<div dangerouslySetInnerHTML={{ __html: Sec5.text }}/>} 
                                image={""} 
                                version={"v1"}/>

                            <ContactInfo 
                                where= {Sec5.where} 
                                when={Sec5.when} 
                                who={Sec5.who} 
                                mobile={Sec5.mobile}
                                email={Sec5.email}/>
                        </section>)}
                        {Sec6 && (<section 
                            id ={Sec6.secId} 
                            className={styles.sec2}>

                            <PageInfo 
                                title={Sec6.header} 
                                description={<div dangerouslySetInnerHTML={{ __html: Sec6.text }}/>} 
                                image={""} 
                                version={"v1"}/>

                            <ContactInfo 
                                where= {Sec6.where} 
                                when={Sec6.when} 
                                who={Sec6.who} 
                                mobile={Sec6.mobile}
                                email={Sec6.email}/>
                        </section>)}
                        {mandagsbedegruppe &&(<section 
                            id ={mandagsbedegruppe.secId} 
                            className={styles.sec3}>

                            <PageInfo 
                                title={mandagsbedegruppe.header} 
                                description={<div dangerouslySetInnerHTML={{ __html: mandagsbedegruppe.text }}/>} 
                                image={""} 
                                version={"v1"}/>

                            <ContactInfo 
                                where= {mandagsbedegruppe.where} 
                                when={mandagsbedegruppe.when} 
                                who={mandagsbedegruppe.who} 
                                mobile={mandagsbedegruppe.mobile}
                                email={mandagsbedegruppe.email}/>
                        </section>)}
                        {u1 &&(<section 
                            id ={mandagsbedegruppe.secId} 
                            className={styles.sec2}>

                            <PageInfo 
                                title={u1.header} 
                                description={<div dangerouslySetInnerHTML={{ __html: u1.text }}/>} 
                                image={""} 
                                version={"v1"}/>

                            <ContactInfo 
                                where= {u1.where} 
                                when={u1.when} 
                                who={u1.who} 
                                mobile={u1.mobile}
                                email={u1.email}/>
                        </section>)}
                    </div>
                );
            }
        }/>
    );
}